import React from 'react';
import * as Backend from '../backend.js';
import * as util from '../other/util.js';
import * as ICONS from "../other/icons.js";

// Shows all quests (quests) for the player
class QuestView extends util.GameComponent {
    constructor(props) {
        super(props);
        this.state = { quests: null };
    }

    refreshState() {
        Backend.getQuests((res) => {
            if (res.success) {
                if (!res.success) {
                    alert(res.error);
                }
                const quest_id = this.props.params.quest_id;
                const selected_quest = res.quests.find(quest => quest.id === quest_id);
                if (selected_quest == null) {
                    this.props.navigate('/game/quests/' + res.quests[0].id, { replace: true });
                }
                this.setState({ quests: res.quests });
            }
        });
    }

    render() {
        if (!this.hasCurrentState()) {
            return (<util.LoadingBar2 />);
        }

        let quests = this.state.quests;
        let quest_id = this.props.params.quest_id;
        let selected_quest = quests.find(quest => quest.id === quest_id) || quests[0];

        return (
            <div className="fade-in">
                <div style={{ display: "flex" }}>
                    <div style={{ flex: "15%" }}>
                        <QuestList quests={quests} selectQuest={q => this.selectQuest(q)} />
                    </div>
                    <div style={{ flex: "10%" }} />
                    <div style={{ flex: "75%" }}>
                        <Quest quest={selected_quest} questCallback={(info) => {
                            this.questCallback(info)
                        }} />
                    </div>
                </div>
                <util.JsonDebug obj={quests} />
            </div >
        );
    }

    questCallback(info) {
        Backend.tryQuestReply(info, (res) => {
            if (!res.success) {
                alert(res.error);
            }
            this.setState({ quests: res.quests });
        });
    }

    selectQuest(quest) {
        this.props.navigate('/game/quests/' + quest.id);
    }
}

class QuestList extends React.Component {
    render() {
        const quests = this.props.quests;

        return (
            <div className="scroll-area-sticky">
                <h3>Active</h3>
                <ul>
                    {quests.map((quest, idx) => !quest.complete ?
                        <li key={idx}><QuestLink quest={quest} idx={idx}
                            selectQuest={(m) => this.props.selectQuest(m)} /></li> : null)}
                </ul>
                <h3>Completed</h3>
                <ul>
                    {quests.map((quest, idx) => quest.complete ?
                        <li key={idx}>
                            <QuestLink quest={quest} idx={idx}
                                selectQuest={(m) => this.props.selectQuest(m)} />
                        </li> : null)}
                </ul>
            </div>
        );
    }
}

class QuestLink extends React.Component {
    render() {
        let class_name = this.props.quest.urgent ? "link-button-danger" : "link-button";
        let quest = this.props.quest;

        return (<div className={class_name}
            onClick={() => this.props.selectQuest(quest)}
            style={{ textDecoration: this.props.quest.complete ? "line-through" : undefined }}>
            {this.props.quest.name}
        </div>);
    }
}

class Quest extends React.Component {
    render() {
        const quest = this.props.quest;

        return (
            <div>
                <div className="scroll-area-sticky">
                    <h2 style={{ marginBottom: "5px" }}>{quest.complete ? "✅ " : ""}{quest.name}</h2>
                </div>

                <div style={{ padding: "8px", flex: 1 }}>
                    {quest.parts.map((part, idx) => <QuestPart key={idx} part={part} quest={quest}
                        questCallback={(info) => {
                            this.questCallback(info)
                        }} />)}
                </div>
            </div>
        );
    }

    renderCompleteButton() {
        return (
            <div style={{ textAlign: "center" }}>
                <div className="quest-complete-badge" style={{
                    display: "inline-block",
                    backgroundColor: "rgba(102, 255, 153, 0.08)",
                    color: "#66ff99",
                    fontFamily: "'Share Tech Mono', monospace",
                    fontSize: "0.9em",
                    padding: "0.4em 1.2em",
                    border: "1px solid #66ff99",
                    borderRadius: "4px",
                    textTransform: "uppercase",
                    letterSpacing: "0.08em",
                    marginTop: "1.2em",
                    textShadow: "0 0 1px #003322"
                }}>
                    ✅ Completed
                </div>
            </div>
        );
    }

    questCallback(info) {
        info.quest_id = this.props.quest.id;
        this.props.questCallback(info);
    }
}

class QuestPart extends React.Component {
    render() {
        let part = this.props.part;

        switch (part.type) {
            case "TEXT":
                return part.text.split("\n").map((word, idx) => [<p key={idx}>{word}</p>]);
            case "PLANET_SELECTION":
                return (
                    <PlanetChoices planets={part.planets} questCallback={(info) => this.props.questCallback(info)} />);
            case "PLANET_DISPLAY":
                return (<PlanetDisplay planet={part.planet} description={part.description} />);
            case "TASKS":
                return (<Tasks tasks={part.tasks} />);
            case "PROGRESS_BAR":
                return (<ProgressBar progress={part.progress} />);
            case "CHOICES":
                return (<GenericChoices choices={part.choices} questCallback={info => this.props.questCallback(info)} />)
            case "CHOICE_LIST":
                return (<ChoiceList choices={part.choices} questCallback={info => this.props.questCallback(info)} />);
            case "HINT":
                return (<Hint text={part.text} />);
            case "PLANET_NAMED":
                return (<PlanetNamed name={part.name} />);
            case "PLANET_NAME_CHOOSER":
                return (<PlanetNameChooser part={part} questCallback={info => this.props.questCallback(info)} />);
            default:
                return (<div>{"Unknown part: " + part.type}</div>);
        }
    }
}

// Tasks ----------------------------------------------------------------------------------------------------------------------

class Tasks extends React.Component {
    render() {
        let tasks = this.props.tasks;

        return (
            <div>
                <p>Tasks:</p>
                <div style={{ marginLeft: "24px" }}>
                    {tasks.map((task) => (<Task key={task.id} task={task} />))}
                </div>
            </div>
        );
    }
}

class Task extends React.Component {
    render() {
        let task = this.props.task;

        if (task.complete) {
            return (
                <li key={task.id} style={{ color: "green", margin: "5px" }}>
                    <span style={{ textDecoration: "line-through" }}>{task.name}</span> <span
                        className="boring-info-text">{task.description}</span>
                </li>
            )
        } else {
            return (
                <li key={task.id} style={{ color: "silver", margin: "5px" }}>
                    <span>{task.name}</span> <span className="boring-info-text">{task.description}</span>
                </li>
            )
        }
    }
}

// ProgressBar ----------------------------------------------------------------------------------------------------------------------

class ProgressBar extends React.Component {
    render() {
        let progress = this.props.progress;
        let percentage = ((progress.current / progress.total) * 100).toFixed();
        let percentage_text = percentage + "%";

        // return (<p>{progress.current}/{progress.total}</p>)

        return (
            <div>
                <p>Progress:</p>
                <div style={{ marginLeft: "24px" }}>
                    <div className="quest-progress" style={{ width: "300px", textAlign: "center" }}>
                        <div style={{ width: percentage_text }}>{percentage_text}</div>
                    </div>
                </div>
            </div>
        );
    }
}

// PlanetChoices ----------------------------------------------------------------------------------------------------------------------

class PlanetChoices extends React.Component {
    render() {
        let planets = this.props.planets;

        return (
            <div>
                {planets.map((planet) => (
                    <PlanetChoice key={planet.id} planet={planet} questCallback={this.props.questCallback} />))}
            </div>
        );
    }
}

class PlanetChoice extends React.Component {
    render() {
        let planet = this.props.planet;

        return (
            <div style={{ display: "flex" }}>
                <div style={{ flex: "20%" }}>
                    <img src={ICONS.PLANETS[planet.astro_info.icon]} alt={planet.astro_info.icon}
                        style={{ padding: "16px", width: "180px" }} />
                </div>
                <div style={{ flex: "70%" }}>
                    <h3>{planet.name}</h3>
                    <p className="boring-info-text">{planet.description}</p>
                    <button className="cool-button" onClick={() => {
                        this.props.questCallback({ planet_id: planet.id });
                    }}> Select
                    </button>
                </div>
            </div>
        );
    }
}

// Planet ----------------------------------------------------------------------------------------------------------------------

class PlanetDisplay extends React.Component {
    render() {
        const planet = this.props.planet;
        const description = this.props.description;

        return (
            <div style={{ display: "flex" }}>
                <div style={{ flex: "20%" }}>
                    <img src={ICONS.PLANETS[planet.astro_info.icon]} alt={planet.astro_info.icon}
                        style={{ padding: "16px", width: "180px" }} />
                </div>
                <div style={{ flex: "70%" }}>
                    <h3>{planet.name}</h3>
                    <p className="boring-info-text">{description}</p>
                </div>
            </div>
        );
    }
}

class PlanetNameChooser extends React.Component {
    constructor(props) {
        super(props);
        this.state = { name: "" };
    }

    render() {
        let planet = this.props.part.planet;
        if (this.props.part.complete) {
            return <div style={{ textAlign: "center" }}>
                <util.PlanetLink planet={planet} showOwner={false} />
                <span> is our home now. Cheers!</span>
            </div>;
        }

        return (
            <div style={{ textAlign: "center" }}>
                <input type="text"
                    style={{ fontSize: "24px" }}
                    placeholder={planet.name}
                    value={this.state.name}
                    onChange={(event) => {
                        if (event.target.value.length <= 128) {
                            this.setState({ name: event.target.value });
                        }
                    }}
                    onKeyPress={(event) => {
                        if (event.key === "Enter" && this.state.name.length >= 3) {
                            this.props.questCallback({ planet_name: this.state.name });
                        }
                        return false;
                    }}
                />
                <button className="cool-button" style={{ marginLeft: "32px" }} onClick={() => {
                    if (this.state.name.length === 0 || (3 <= this.state.name.length && this.state.name.length <= 128)) {
                        this.props.questCallback({ planet_name: this.state.name });
                    } else {
                        alert("Planet name needs to be between 3 and 128 characters.");
                    }
                }}> Ok
                </button>
            </div>
        );
    }
}

// GenericChoices ----------------------------------------------------------------------------------------------------------------------

class GenericChoices extends React.Component {
    render() {
        let choices = this.props.choices;

        return (
            <div>
                {choices.map((choice) => (
                    <GenericChoice key={choice.id} choice={choice} questCallback={this.props.questCallback} />))}
            </div>
        );
    }
}

class GenericChoice extends React.Component {
    render() {
        let choice = this.props.choice;

        return (
            <div>
                <h3>{choice.name}</h3>
                <p className="boring-info-text">{choice.description}</p>
                <button className="cool-button" onClick={() => {
                    this.props.questCallback({ choice_id: choice.id });
                }}> Select
                </button>
            </div>
        );
    }
}

// ChoiceList ----------------------------------------------------------------------------------------------------------------------

class ChoiceList extends React.Component {
    render() {
        let choices = this.props.choices;

        return (
            <div>
                {choices.map((choice) => (
                    <div key={choice.id}>
                        <div className="link-button" onClick={() => {
                            this.props.questCallback({ choice_id: choice.id });
                        }}> {choice.title}
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}

// Hint ----------------------------------------------------------------------------------------------------------------------

class Hint extends React.Component {
    render() {
        let text = this.props.text;

        return (
            <div>
                <div className="hint-box">
                    Hint: {text}
                </div>
            </div>
        );
    }
}

// PlanetNamed ----------------------------------------------------------------------------------------------------------------------

class PlanetNamed extends React.Component {
    render() {
        let name = this.props.name;

        return (
            <div style={{
                color: "#ffffff",
                fontFamily: "'Share Tech Mono', monospace",
                fontSize: "1em",
                margin: "1.2em 0",
                textAlign: "center"
            }}>
                <span className="planet-named-emoji-bounce" role="img" aria-label="champagne">🍾</span>
                <strong style={{
                    letterSpacing: "0.03em",
                    margin: "0 0.5em"
                }}>
                    {name}
                </strong>
                <span className="planet-named-emoji-bounce" role="img" aria-label="champagne">🍾</span>
            </div>
        );
    }
}

export default util.withParamsAndNavigation(QuestView);
